import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Copy } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { stripMarkdownHeading } from '../../utils/markdown';
import themeStyles from './styles/ColorPreviewPanel.styles';
const ColorPreview = themeStyles.apply(Box, 'ColorPreview');
const ColorPreviewPanel = ({ extColor, intColor }) => {
    const { t } = useTranslation();
    const composedColorName = compiler(stripMarkdownHeading(t('Shared.Common.concatWithAmpersandLabel', {
        prependString: extColor.colorName,
        suffixString: intColor.colorName,
    })));
    return (React.createElement(Box, { "data-testid": "cy-color-preview-panel" },
        React.createElement(ColorPreview, { extColor: extColor.hexValue, intColorImage: intColor.url, "data-testid": "cy-color-preview" }),
        React.createElement(Copy, { size: "extraSmall", fontFamily: "bold", "data-testid": "cy-color-preview-color-name" }, composedColorName)));
};
export default ColorPreviewPanel;
